import EyeIcon from "@/assets/icons/Eye";
import HiddenEye from "@/assets/icons/HiddenEye";
import { Input, InputField } from "@/components/ui/input";
import { useT } from "@transifex/react";
import { useState } from "react";
import { Pressable, type TextInputProps } from "react-native";

interface PasswordInputProps extends TextInputProps {
  value: string;
  onChangeText: (text: string) => void;
  onBlur: () => void;
  onFocus: () => void;
  error?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({ value, onChangeText, onBlur, onFocus, error, ...props }) => {
  const t = useT();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <Input
      className={`bg-background-100 h-[52px] pl-[8px] pr-[16px] py-[8px] rounded-[6px] ${error ? "bg-error-50 border-error-400" : "bg-background-100 border-secondary-700"}`}
    >
      <InputField
        placeholder={t("Enter Your Password")}
        value={value}
        onChangeText={onChangeText}
        onBlur={onBlur}
        onFocus={onFocus}
        secureTextEntry={!isPasswordVisible}
        className="text-typography-900 text-[16px] font-[400] leading-[22px] align-middle placeholder-text-typography-900 placeholder-opacity-50"
        {...props}
      />
      <Pressable onPress={togglePasswordVisibility} style={{ alignItems: "center", justifyContent: "center" }}>
        {isPasswordVisible ? <EyeIcon /> : <HiddenEye stroke="none" fill="bg-typography-900" />}
      </Pressable>
    </Input>
  );
};

export default PasswordInput;
